<section class="admin-companies-page">
  <div class="admin-companies-page__header">
    <div>
      <h2 class="admin-companies-page__title">
        {{ "COMPONENTS.ADMIN_PANEL.COMPANIES.TITLE" | translate }}
      </h2>
      <p class="admin-companies-page__subtitle">
        {{ "COMPONENTS.COMPANIES.SUPER_ADMIN_HINT" | translate }}
      </p>
    </div>
  </div>

  <div class="admin-companies-page__toolbar">
    <div class="admin-companies-page__search-block">
      <label class="admin-companies-page__label" for="admin-companies-search">
        {{ "COMPONENTS.ADMIN_PANEL.COMPANIES.SEARCH_LABEL" | translate }}
      </label>
      <input
        id="admin-companies-search"
        type="text"
        class="input-field-lg admin-companies-page__search-input"
        [formControl]="searchControl"
        [placeholder]="'COMPONENTS.COMPANIES.SEARCH_PLACEHOLDER' | translate"
      />
    </div>

    <div class="admin-companies-page__mode-block">
      <span class="admin-companies-page__label">
        {{ "COMPONENTS.COMPANIES.SUPPORT_MODE_LABEL" | translate }}
      </span>
      <div
        class="admin-companies-page__access-toggle"
        role="group"
        [attr.aria-label]="'COMPONENTS.COMPANIES.SUPPORT_MODE_LABEL' | translate"
      >
        @for (mode of supportModeCards; track mode.value) {
          <button
            type="button"
            class="admin-companies-page__access-button"
            [class.admin-companies-page__access-button--active]="selectedAccessMode === mode.value"
            [ngbTooltip]="mode.tooltipKey | translate"
            container="body"
            (click)="setAccessMode(mode.value)"
          >
            {{ mode.titleKey | translate }}
          </button>
        }
      </div>
    </div>
  </div>

  @if (isLoading) {
    <p class="admin-companies-page__empty">
      {{ "MESSAGES.LOADING" | translate }}
    </p>
  } @else if (companies$ | async; as companies) {
    @if (companies.length > 0) {
      <div class="admin-companies-page__grid">
        @for (company of companies; track company.id) {
          <article class="admin-companies-page__company-card">
            @if (company.imageUrl && company.imageUrl !== notFound) {
              <img
                class="admin-companies-page__company-image"
                [src]="company.imageUrl"
                alt="company image"
              />
            } @else {
              <div class="admin-companies-page__company-image admin-companies-page__company-image--placeholder">
                {{ company.name | abbreviation }}
              </div>
            }

            <div class="admin-companies-page__company-body">
              <h3 class="admin-companies-page__company-title">
                {{ company.name }}
              </h3>
              <button
                type="button"
                class="btn-primary admin-companies-page__company-action"
                (click)="openCompany(company)"
              >
                {{ "BUTTONS.OPEN" | translate }}
              </button>
            </div>
          </article>
        }
      </div>
    } @else {
      <p class="admin-companies-page__empty">
        {{ "COMPONENTS.COMPANIES.NO_RESULTS" | translate }}
      </p>
    }
  }
</section>
